import { render, staticRenderFns } from "./findPassword.vue?vue&type=template&id=2f31c332&scoped=true"
import script from "./findPassword.vue?vue&type=script&lang=js"
export * from "./findPassword.vue?vue&type=script&lang=js"
import style0 from "./findPassword.vue?vue&type=style&index=0&id=2f31c332&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f31c332",
  null
  
)

export default component.exports